module.exports = __webpack_public_path__ + "static/carbon-table-context-menu-61522ba90e840c664735a605af68aabe.png";